import * as utils from '@utils/form';

export const FORM_FIELD = {
  TITLE: {
    name: 'title',
    label: 'Module title:',
    rules: [{ required: true, message: 'A title module required' }],
    placeholder: 'Title name...',
  },
  VIDEOS: {
    name: 'videoIds',
    label: 'Current videos',
    rules: [{ min: 1, max: 30 }],
    serialize: (field, values) => {
      const value = values[field.name];
      return value ? { [field.name]: value.map(({ id }) => id.split('_')[0]) } : null;
    },
  },
  TAG: {
    name: 'tag',
    // label: 'Filter by video tag',
    rules: [{ required: true, message: 'A video tag is required' }],
    serialize: utils.relatedInsideTrackSerializer,
  },
  PLAYLIST: {
    name: 'videoPlaylist',
    // label: 'Filter by video playlist',
    rules: [{ required: true, message: 'A video playlist is required' }],
    serialize: utils.relatedInsideTrackSerializer,
  },
  LAYOUT: {
    name: 'layout',
  },
  SLUG: {
    name: 'slug',
  },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);

export const MODULE_LAYOUT = {
  WITH_1_COLUMN: {
    key: 2,
    label: '2 column',
  },
  WITH_2_COLUMNS: {
    key: 3,
    label: '3 columns',
  },
};
export const MODULE_LAYOUTS = Object.values(MODULE_LAYOUT);

export const MODE = {
  MANUAL: {
    value: 'manually',
    label: 'Choose videos manually',
  },
  TAG: {
    value: 'automatically',
    label: 'By tag',
  },
  PLAYLIST: {
    value: 'playlist',
    label: 'By playlist',
  },
};
export const MODES = Object.values(MODE);

export const INITIAL_VALUES = {
  [FORM_FIELD.VIDEOS.name]: [],
};
